/**
 * Created by Nisarg on 7/19/2017.
 */
import firebase from 'firebase';
import $ from 'jquery';
import ReactGA from 'react-ga';

$(window).on("orientationchange", setMobOrientation());

function setMobOrientation() {
    let isMobile = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
    /* ===== Set banner image responsive starts ===== */
    for (let i = 0; i < document.styleSheets.length; i++) {
        if (document.styleSheets[i].title == "style") {
            const classes = document.styleSheets[i].rules || document.styleSheets[i].cssRules;
            if (classes.length > 0) {
                for (let j = 0; j < classes.length; j++) {
                    if (classes[j].selectorText == ".banner") {
                        const _styles = classes[j].style;
                        const pTop = parseInt(_styles.paddingTop);
                        const pRight = parseInt(_styles.paddingRight);
                        const pBottom = parseInt(_styles.paddingBottom);
                        const pLeft = parseInt(_styles.paddingLeft);
                        const _sectionBanner = $("section.sec-banner")[0];
                        const sectionHeight = $(_sectionBanner).height();

                        const _height = pTop + pRight + pBottom + pLeft + sectionHeight;
                        const _width = $(_sectionBanner).width();
                        const _imgBanner = $("img.img-banner")[0];

                        let imgHeight = isMobile ? 'auto' : _height + "px";
                        $(_imgBanner).css({
                            height: imgHeight,
                            width: isMobile ? 'auto' : _width + "px"
                        });
                        const _divExplore = $("div.div-explore")[0];
                        if (!isMobile) {
                            const marginTop = $(_sectionBanner).height() + 70;
                            $(_divExplore).css({'margin-top': "-" + marginTop + "px"});
                        }
                        else {   //if mobile
                            if (window.innerHeight > window.innerWidth) {  //if (window.screen.orientation.type == "portrait-primary") { //only for portrait
                                let mobSecBannerHeight = _height * 60 / 100; //40% of the screen ratio
                                // $(_sectionBanner).css({
                                //     'height': mobSecBannerHeight + "px",
                                //     'min-height': _width + 25 + "px"
                                // });
                                $(_sectionBanner).css({
                                    'height': mobSecBannerHeight + "px"
                                });
                                let mobImgHeight = mobSecBannerHeight * 85 / 100;  //_height * 40 / 100;
                                let mobImgMarginTop = _width / 2.5;

                                $(_imgBanner).css({
                                    'height': mobSecBannerHeight + "px",
                                    'margin-top': "-" + mobImgMarginTop + "px"
                                });
                                $(_divExplore).css({'margin-top': "-" + mobImgMarginTop + "px"});
                                // $("section.sec-banner").next("section").css({"padding-top": "0px"});
                            }
                            else {  //landscape-primary
                                let mobImgHeight = _height * 45 / 100;
                                let mobImgMarginTop = sectionHeight / 2;
                                $(_sectionBanner).css({
                                    'min-height': mobImgHeight + 25 + "px"
                                });
                                $(_imgBanner).css({
                                    'height': mobImgHeight + "px",
                                    'margin-top': "-" + mobImgMarginTop + "px"
                                });
                                $(_divExplore).css({'margin-top': "-" + mobImgMarginTop + "px"});
                            }
                            if ($("section.sec-banner").next("section").attr("data-islandType") != "private") {
                                $("section.sec-banner").next("section").css({"padding-top": "0px"});
                            }

                            const searchFormWidth = $("form.search-form").width();
                            $("div#react-autowhatever-1").css({
                                'max-height': (window.innerHeight / 2) + "px",
                                width: "100%"
                            });
                        }
                    }
                }
            }
        }
    }

    /* ===== Set banner image responsive ends ===== */
}

export default class HauteFire {
    constructor() {
        let config = {
            apiKey: "AIzaSyDhtIn35zo7sfJGZZawxFzPf3tFt7oT76w",
            authDomain: "haute-islands.firebaseapp.com",
            databaseURL: "https://haute-islands.firebaseio.com",
            projectId: "haute-islands",
            storageBucket: "haute-islands.appspot.com",
            messagingSenderId: "709476992106"
        };

        if (firebase.apps.length == 0)
            firebase.initializeApp(config);
    }

    createEnquiry(obj) {
        const id = Date.now();
        obj.id = id;

        firebase.database().ref("EnquiryDetails/" + id).set(obj);
    }

    setBanner() {
        setMobOrientation();
    }

    isMobile() {
        return (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
    }

    filterBy(continents, priceLists, AllIslands) {
        let continentParties = [], priceListParties = [], FilterIslands = [];
        let continentsAll = continents.filter((obj) => {
            return obj.trim().toLowerCase() == "all"
        });
        if (continentsAll.length > 0) {
            FilterIslands = AllIslands;
        }
        else {
            for (let i = 0; i < continents.length; i++) {
                let continent = continents[i].trim().toLowerCase();
                if (continent == "all") {
                    continentParties = AllIslands;
                }
                else {
                    AllIslands.filter((island) => {
                        if (continent.includes("australia")) {
                            if (island.continent.trim().toLowerCase() == ("australia" || "oceania")) {
                                continentParties.push(island);
                            }
                        }
                        else {
                            if (island.continent.trim().toLowerCase() == continent) {
                                continentParties.push(island);
                            }
                        }
                    });
                }
            }
            if (continentParties.length > 0) {
                let priceListAll = priceLists.filter((obj) => {
                    return obj.trim().toLowerCase() == "all"
                });
                if (priceListAll.length > 0) {
                    FilterIslands = continentParties;
                }
                else {
                    let priceFilterContinents = [];
                    for (let i = 0; i < priceLists.length; i++) {
                        let priceList = parseInt(priceLists[i].trim());

                        continentParties.filter((island) => {
                            if (island.price == priceList) {
                                priceFilterContinents.push(island)
                            }
                        });
                    }
                    FilterIslands = priceFilterContinents;
                }
            }

        }

        return FilterIslands;
    }

    hauteGoogleAnalytics() {
        ReactGA.initialize('UA-107947193-1');
        ReactGA.pageview(window.location.pathname + window.location.search);
    }
}



// WEBPACK FOOTER //
// ./src/HauteFire.js